export function getSearchLimits ({ state, commit }, { page = 1, search = '' }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/searchlimits', { params: { page, search } })
      .then((response) => {
        if (response.data.searchlimits) {
          commit('setSearchLimits', response.data.searchlimits)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getSearchLimit ({ state, commit }, searchlimitId) {
  return new Promise((resolve, reject) => {
    if (searchlimitId) {
      axiosInstance.get('/v1/searchlimits/' + searchlimitId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No searchlimit id'))
    }
  })
}

export function getCreateSearchLimit ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/searchlimits/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createSearchLimit ({ state, commit }, { clientID, clientKEY, search_limit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/searchlimits', { clientID, clientKEY, search_limit })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditSearchLimit ({ state, commit }, searchlimitId) {
  return new Promise((resolve, reject) => {
    if (searchlimitId) {
      axiosInstance.get('/v1/searchlimits/' + searchlimitId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No searchlimit id'))
    }
  })
}

export function getEditSearchLimitByCK ({ state, commit }, clientKEY) {
  return new Promise((resolve, reject) => {
    if (clientKEY) {
      axiosInstance.get('/v1/searchlimits/' + clientKEY + '/ckedit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No client key'))
    }
  })
}

/* eslint-disable-next-line */
export function editSearchLimit ({ state, commit }, { id, clientID, clientKEY, search_limit }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/searchlimits/' + id, { clientID, clientKEY, search_limit })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No searchlimit id'))
    }
  })
}

export function deleteSearchLimit ({ state, commit }, searchlimitId) {
  return new Promise((resolve, reject) => {
    if (searchlimitId) {
      axiosInstance.delete('/v1/searchlimits/' + searchlimitId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No searchlimit id'))
    }
  })
}

export function getTodayLimits ({ state, commit }, accounts) {
  return new Promise((resolve, reject) => {
    if (accounts && accounts.length > 0) {
      axiosInstance.post('/v1/searchlimits/todaylimits', { accounts })
        .then((response) => {
          if (response.data.limits) {
            commit('setTodayLimits', response.data.limits)
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa accounturi'))
    }
  })
}

export function getTodayLimit ({ state, commit }, account) {
  return new Promise((resolve, reject) => {
    if (account) {
      axiosInstance.post('/v1/searchlimits/todaylimit', { account })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa account'))
    }
  })
}

export function updateTodayLimit ({ state, commit }, { account, search_limit }) {
  return new Promise((resolve, reject) => {
    if (account) {
      axiosInstance.patch('/v1/searchlimits/todaylimit', { account, search_limit })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa account pentru update'))
    }
  })
}
